import { render, staticRenderFns } from "./Utm.vue?vue&type=template&id=e8af6f7c&scoped=true"
import script from "./Utm.vue?vue&type=script&lang=js"
export * from "./Utm.vue?vue&type=script&lang=js"
import style0 from "./Utm.vue?vue&type=style&index=0&id=e8af6f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8af6f7c",
  null
  
)

export default component.exports